import { render, staticRenderFns } from "./student_linshi.vue?vue&type=template&id=27a7d20e&scoped=true"
import script from "./student_linshi.vue?vue&type=script&lang=js"
export * from "./student_linshi.vue?vue&type=script&lang=js"
import style0 from "./student_linshi.vue?vue&type=style&index=0&id=27a7d20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a7d20e",
  null
  
)

export default component.exports